module.exports = __webpack_public_path__ + "static/media/GolfLogo.f46faf27.png";